import { getSettingsRootUrl } from './getSettingsRootUrl';
export function getSettingsPath(subpath) {
  return `${getSettingsRootUrl()}/${subpath}`;
}